import React, {
  useCallback, // Memoriza funções evitando recriação a cada render
  useRef,      // Permite acessar métodos do formulário diretamente
  useEffect,   // Executa efeitos colaterais (ex: chamada API)
  useState,    // Controla estado do componente
  useMemo,     // Memoriza valores derivados evita
} from 'react';

import { 
  FiEye, // icon para olhos 
  FiSearch, // icon para lupa de pesquisa
  FiUser, // icon que representa usuário
  FiTrello // icon que representa o trello ---> vai ser o nosso icon de planejar

} from 'react-icons/fi'; // Ícone visual usado no botão de ação

import { 
  useLocation // 
} from 'react-router-dom';

import {
  Box,            // Container base do Chakra
  Button,         // Componente botão padrão
  Divider,        // Linha divisória visual
  Flex,           // Container flexível (layout responsivo)
  IconButton,     // Botão contendo apenas ícone
  Tag,            // Componente visual de destaque
  HStack,         // Agrupador horizontal
  Text,           // Texto Chakra
  useToast,       // Hook para notificações visuais
  Heading,        // Título
  Tooltip,
  UnorderedList,        // Tooltip ao passar mouse
} from '@chakra-ui/react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react';

import { FormHandles } from '@unform/core'; // Tipagem da referência do formulário
import { Form } from '@unform/web';         // Componente formulário Unform
import * as Yup from 'yup'; // Biblioteca de validação de dados

import RadioChakra from '~/shared/components/InputChakra/RadioChakra'; // Radio custom
import SelectChakra from '~/shared/components/InputChakra/SelectChakra'; // Select custom
import LoadingAbsolute from '~/shared/components/LoadingAbsolute'; // Loader visual
import SectionHeader from '~/shared/components/SectionHeader'; // Cabeçalho da página
import Table, { THeadProps } from '~/shared/components/Table'; // Tabela custom
import api from '~/shared/services/api'; // Serviço Axios
import getValidationErrors from '~/utils/getValidationErrors'; // Converte erro Yup

import BadgeStatusInfo from '../../components/BadgeStatusInfo'; // Badge status


// ======================================================
// INTERFACE PRINCIPAL DOS DADOS
// Representa cada linha retornada pela API
// ======================================================

interface ListInfoActiviesExpected {
  number_plan:number                 // Número do planejamento
  number_attedence: number;               // Número atendimento
  number_act: number;               // Número atividade
  employee: string;                 // Nome funcionário
  demand: string;                   // Nome demanda
  company_client: string;           // Empresa cliente
  competence: string;               // Competência contábil
  activity_name:string                   // Nome da Atividade
  start_planned: string;            // Data início planejada
  end_planned: string;              // Data fim planejada
  inicio_atendimento?: string;      // Início real atendimento
  fim_atendimento?: string;         // Fim real atendimento
  duration_activity: string;        // Duração prevista
  time_reconde: string;             // Tempo executado que o funcionario esta executando o atendimento
  status_attedence: string;         // Status atendimento
  status_entrega: string;           // Status entrega
  status_color_attedence: string;   // Cor status
}



// ======================================================
// COMPONENTE PRINCIPAL
// ======================================================

const AnalyzeActivitiesExpected: React.FC = () => {

  // ----------------------------------------------------
  // REFERÊNCIA DO FORMULÁRIO
  // Permite:
  // reset, submit, setErrors etc.
  // ----------------------------------------------------
  const formRef = useRef<FormHandles>(null);

  // ----------------------------------------------------
  // HOOK DE NOTIFICAÇÃO
  // ----------------------------------------------------
  const addToast = useToast();

  // ----------------------------------------------------
  // OBTÉM a QueryString do useLocation
  // ----------------------------------------------------

  const { search } = useLocation();


  // ----------------------------------------------------
  // ESTADOS DE CONTROLE VISUAL
  // ----------------------------------------------------

  const [loaded, setLoaded] = useState(false); // Controla loader global

  const [loadingSubmit, setLoadingSubmit] = useState(false); // Loader botão filtrar

  const [loadingCleanFilter, setLoadingCleanFilter] = useState(false); // Loader limpar filtro

  const [loadingActivitiesExcepted, setLoadingActivitiesExcepted] = useState(false); // Loader tabela

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [originalActivities, setOriginalActivities] =
  useState<ListInfoActiviesExpected[]>([]);

  // ----------------------------------------------------
  // LISTA ORIGINAL (NUNCA FILTRADA)
  // Fonte única e segura dos dados
  // ----------------------------------------------------

  const [allActivities, setAllActivities] =
    useState<ListInfoActiviesExpected[]>([]);



  // ----------------------------------------------------
  // LISTA FILTRADA (UTILIZADA NA TABELA)
  // ----------------------------------------------------

  const [listAllInfoActivity, setListAllInfoActivity] =
    useState<ListInfoActiviesExpected[]>([]);



  // ----------------------------------------------------
  // OPTIONS DO SELECT FUNCIONÁRIO
  // Remove duplicidade usando Map
  // ----------------------------------------------------

  const selectEmployeesOptions = useMemo(() => {

    return Array.from(
      new Map(
        allActivities.map(item => [
          item.employee, // chave única
          {
            value: item.employee, // valor enviado form
            label: item.employee, // texto exibido
          },
        ]),
      ).values(),
    );

  }, [allActivities]); // Recalcula apenas quando lista original muda



  // ----------------------------------------------------
  // OPTIONS DO SELECT DEMANDA
  // ----------------------------------------------------

  const selectDemandsOptions = useMemo(() => {

    return Array.from(
      new Map(
        allActivities.map(item => [
          item.demand,
          {
            value: item.demand,
            label: item.demand,
          },
        ]),
      ).values(),
    );

  }, [allActivities]);



// ======================================================
// CONTROLE MODAL DETALHES
// ======================================================

// Hook Chakra responsável por controlar abertura e fechamento da modal
const { isOpen, onOpen, onClose } = useDisclosure();

// Armazena atividade selecionada para exibir detalhes
const [selectedActivity, setSelectedActivity] =
  useState<ListInfoActiviesExpected | null>(null);

// ======================================================
// ABRE MODAL COM DETALHES DA ATIVIDADE
// ======================================================

const handleOpenDetails = useCallback((activity: ListInfoActiviesExpected) => {

  // Salva atividade clicada
  setSelectedActivity(activity);

  // Abre modal
  onOpen();

}, [onOpen]);


  // ----------------------------------------------------
  // TÍTULOS DA TABELA
  // ----------------------------------------------------

  const tableTitles = useMemo((): THeadProps[] => {

    return [
      { title: 'Funcionário' },
      { title: 'Atividade' },
      { title: 'Demanda' },
      { title: 'Competência' },
      { title: 'Empresa' },
      { title: 'Status Atendimento'},
      { title: 'Status Atividade'},
      { title: 'Ações' },
    ];

  }, []);

  const labelsAcoes:string[]=['Detalhes Atividade','Planejar/Replanejar']; 

  // ----------------------------------------------------
  // FUNÇÃO BUSCA API
  // ----------------------------------------------------

  const infoActivitiesExpected = async () => {

      try {

        setLoadingActivitiesExcepted(true);

        const queryParams = Object.fromEntries(new URLSearchParams(search));

        const finalParams = Object.keys(queryParams).length > 0 
          ? queryParams 
          : { listToday: 1 };

        const { data } = await api.get<ListInfoActiviesExpected[]>(
          '/forecast/list-activities-expected-delivery',
          {
            params: finalParams,
          },
        );

        setOriginalActivities(data);
        setAllActivities(data);
        setListAllInfoActivity(data);

      } catch {

        addToast({
          status: 'error',
          title: 'Erro ao carregar atividades',
          position: 'top-right',
        });

      } finally {

        setLoaded(true);
        setLoadingActivitiesExcepted(false);

      }

    };
  // ======================================================
  // FUNÇÃO CENTRAL DE FILTROS
  // EVITA DUPLICAÇÃO DE LÓGICA
  // ======================================================

  const applyLocalFilters = useCallback((data:any, source:ListInfoActiviesExpected[]) => {

    let filtered = [...source];

    // ------------------------------------------------
    // FILTRO STATUS
    // ------------------------------------------------

    if (data.delay === '1') {
      filtered = filtered.filter(
        item => item.status_attedence?.toLowerCase() === 'iniciado'
      );
    }

    if (data.delay === '2') {
      filtered = filtered.filter(
        item => item.status_attedence?.toLowerCase() === 'pausado'
      );
    }

    if (data.delay === '3') {
      filtered = filtered.filter(
        item => item.status_attedence?.toLowerCase() === 'não iniciado'
      );
    }

    // ------------------------------------------------
    // FILTRO FUNCIONÁRIO
    // ------------------------------------------------

    if (data.employee) {
      filtered = filtered.filter(
        item => item.employee === data.employee
      );
    }

    // ------------------------------------------------
    // FILTRO DEMANDA
    // ------------------------------------------------

    if (data.demand) {
      filtered = filtered.filter(
        item => item.demand === data.demand
      );
    }

    // Atualiza tabela
    setListAllInfoActivity(filtered);

  }, []);

  // ======================================================
  // FILTRO COM BACKEND (DATA)
  // ======================================================

  const handleDataSubmit = useCallback(async (data:any) => {

    const { start_planned, end_planned } = data;

    // ------------------------------------------------
    // VALIDAÇÃO DE DATA
    // ------------------------------------------------
    if (!start_planned || !end_planned) {
      addToast({
        status: 'warning',
        title: 'Filtro incompleto',
        description: 'Informe data inicial e final para aplicar o filtro.',
        position: 'top-right',
        duration: 4000,
        isClosable: true
      });
      return;
    }

    try {

      // CORREÇÃO CRÍTICA
      // garante que loader sempre inicia corretamente
      setLoadingActivitiesExcepted(true);

      const { data: backendData } = await api.post<ListInfoActiviesExpected[]>(
        '/forecast/filter-costumezed',
        {
          status_filter: true,
          dateMin: start_planned,
          dateMax: end_planned
        }
      );

      // CORREÇÃO CRÍTICA
      // após filtro backend a nova base de dados passa a ser essa
      setAllActivities(backendData);

      // mantém a lista exibida consistente
      setListAllInfoActivity(backendData);

      // aplica filtros adicionais locais
      applyLocalFilters(data, backendData);

    } catch (error) {

      console.log('Erro filtro backend', error);

      addToast({
        status: 'error',
        title: 'Erro ao aplicar filtro de data',
        position: 'top-right'
      });

    } finally {

      // CORREÇÃO CRÍTICA
      // evita loader infinito
      setLoadingActivitiesExcepted(false);

    }

  }, [applyLocalFilters, addToast]);


  // ----------------------------------------------------
  // LIMPAR FILTRO
  // ----------------------------------------------------

  const handleCleanFilter = useCallback(() => {

    setLoadingCleanFilter(true);

    formRef.current?.reset();

    setStartDate('');
    setEndDate('');

    // CORREÇÃO CRÍTICA
    // volta para base original da API
    setAllActivities(originalActivities);
    setListAllInfoActivity(originalActivities);

    setTimeout(() => {
      setLoadingCleanFilter(false);
    }, 200);

  }, [originalActivities]);

  // ======================================================
  // SUBMIT FILTRO
  // ======================================================

  const handleSubmit = useCallback(async (data:any) => {

    const hasDateFilter = startDate && endDate;

    try {

      setLoadingSubmit(true);

      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        delay: Yup.string().required(),
      });

      await schema.validate(data, { abortEarly:false });

      // ------------------------------------------------
      // FILTRO BACKEND
      // ------------------------------------------------
      if (hasDateFilter) {

        await handleDataSubmit({
          ...data,
          start_planned: startDate,
          end_planned: endDate
        });

        return;
      }

      // ------------------------------------------------
      // CORREÇÃO CRÍTICA
      // usa sempre a base ativa atual
      // ------------------------------------------------
      applyLocalFilters(data, allActivities);

    } catch (err) {

      if (err instanceof Yup.ValidationError) {
        formRef.current?.setErrors(getValidationErrors(err));
      }

    } finally {

      setLoadingSubmit(false);

    }

  }, [allActivities, applyLocalFilters, handleDataSubmit, startDate, endDate]);

  // ----------------------------------------------------
  // LOAD INICIAL
  // ----------------------------------------------------

  useEffect(() => {
    infoActivitiesExpected();
  }, [search]);


  // -------------------------------------------------------------------
  // Converte uma string de data para o formato: YYYY/MM/DD Às HH:mm
  // --------------------------------------------------------------------

  const replaceDate = (dateString: string): string => {
    const date = new Date(dateString);

    // Verifica se a data é válida para evitar "Invalid Date" na tela
    /* if (isNaN(date.getTime())) {
      return "Data inválida";
    } */

    // Formatando a data
    const datePart = date.toLocaleDateString('pt-BR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).split('/').join('/'); // Transforma DD/MM/YYYY em YYYY/MM/DD

    // Formatando a hora
    const timePart = date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${datePart} às ${timePart}`;
  };

  // ======================================================
  // RENDER JSX
  // ======================================================

  return (
    <Box position="relative">

      {/* Loader global */}
      {!loaded && <LoadingAbsolute min_height={500} />}

      {/* Cabeçalho */}
      <Flex justifyContent="space-between" flexDir={['column', 'row']}>
        <SectionHeader
          title="Entregas Previstas"
          pagename="Gerenciamento de atividades"
          goBackLink="/"
          goBackPage
        />
      </Flex>


      {/* FORMULÁRIO FILTRO */}
      <Form
        ref={formRef} // referência Unform
        onSubmit={
          handleSubmit
        } // função submit
        initialData={{ delay: '0' }} // valor inicial radio
      >

        <Flex flexDir="row" align="flex-end" gap={6} width="100%">

          {/* BLOCO RADIO STATUS */}
          <Flex flexDir="column" minW="220px">

            <Heading size="sm" mb={3} color="gray.500">
              Atendimento
            </Heading>

            <RadioChakra
              name="delay" // Nome campo formulário
              options={[
                { label: 'todos os status', value: '0' },
                { label: 'Iniciado', value: '1' },
                { label: 'Pausado', value: '2' },
                { label: 'Não iniciado', value: '3' },
              ]}
            />

          </Flex>

          {/* BLOCO SELECTS */}
          <Flex flexDir="column" gap={3} minW="300px">

            {/* SELECT FUNCIONÁRIO */}
            <Box>
              <SelectChakra
                width="80%"
                options={selectEmployeesOptions}
                name="employee"
                label="Funcionário"
                placeholder="Todos"
              />
            </Box>

            {/* SELECT DEMANDA */}
            <Box>
              <SelectChakra
                width="80%"
                options={selectDemandsOptions}
                name="demand"
                label="Demanda"
                placeholder="Todas"
              />
            </Box>

          </Flex>

          {/* BLOCO FILTRO POR DATA (BACKEND) */}
          {/* ----------------------------------------------------
            IMPORTANTE
            Esses campos enviam diretamente para o Unform:
            start_planned
            end_planned

            Quando ambos forem enviados:
            → ativa filtro backend (handleDataSubmit)

            Se nenhum for enviado:
            → segue filtro local normalmente
          ---------------------------------------------------- */}


          <Flex
            flexDir="column"
            gap={3}
            minW="260px"
            mb={4}
          >

            {/* DATA INÍCIO */}
            <Box>
              <Heading size="sm" color="gray.500">
                Data início Planejado
              </Heading>

              <input
                type="date"
                name="start_planned"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{
                  height: '3rem',
                  border: '1px solid #E2E8F0',
                  borderRadius: '6px',
                  padding: '0 10px',
                  width: '300px',
                }}
              />
            </Box>

            {/* DATA FIM */}
            <Box mt={5}>
              <Heading size="sm" color="gray.500">
                Data fim Planejado
              </Heading>

              <input
                type="date"
                name="end_planned"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{
                  height: '3rem',
                  border: '1px solid #E2E8F0',
                  borderRadius: '6px',
                  padding: '0 10px',
                  width: '300px',
                }}
              />
            </Box>

          </Flex>

          {/* BLOCO BOTÕES */}
          <Flex flexDir="row" ml={100} mb={8} gap={3} minW="200px">


            <Button
              mx={5}
              width={40}
              onClick={() => formRef.current?.submitForm()}
              colorScheme="green"
              isLoading={loadingSubmit}
              isDisabled={loadingCleanFilter}
            >
              Filtrar
            </Button>

            <Button
              width={40}
              onClick={handleCleanFilter}
              colorScheme="gray"
              isLoading={loadingCleanFilter}
              isDisabled={loadingSubmit}
            >
              Limpar Filtro
            </Button>

          </Flex>

        </Flex>
      </Form>


      { /* <Divider my={10} /> */ } 


      {/* TABELA */}
      <Table
        loading={loadingActivitiesExcepted}
        theadData={tableTitles}
        alignHead='center'
      >

        {            
          // d="flex" -> deixa o layout do box no modo flexBox 
          // alignItems="center" // aninha os layouts filhos ao centro
        }    

        {listAllInfoActivity.map(act => (

          <Box as="tr" key={act.number_act} _hover={{ bg: 'gray.50' }}>

            <Tooltip label={act.employee}>
              <Text as="td" p={2} isTruncated maxW={200}>
                {act.employee}
              </Text>
            </Tooltip>

            <Tooltip label={act.activity_name}>
              <Text as="td" p={2} isTruncated maxW={200}>
                {act.activity_name}
              </Text>
            </Tooltip>

            <Box as="td" p={2}>
              <Tag>{act.demand}</Tag>
            </Box>

            <Text as="td" p={2}>{act.competence}</Text>

            <Text as="td" p={2}>{act.company_client}</Text>

            <Box as="td" textAlign="center">
              <BadgeStatusInfo
                status={act.status_attedence}
                statusColor={act.status_color_attedence}
              />
            </Box>

            {/* <Box as="td" textAlign="center">
              <BadgeStatusInfo
                status={act.status_entrega}
              />
            </Box>  vamos optar por essa opção assim que eu arrumar o back-end */}

            <Box as="td" textAlign="center">
              <Tag>{act.status_entrega.charAt(0).toUpperCase()+act.status_entrega.slice(1)}</Tag>
            </Box>

            <Box as="td" d='flex'>
              <Tooltip label={labelsAcoes[0]}>                
                <HStack justify="center">

                  {/* BOTÃO DETALHES (ABRE MODAL) */}
                  <IconButton
                    aria-label="Ver detalhes da atividade"
                    icon={<FiEye />}
                    variant="ghost"
                    onClick={() => handleOpenDetails(act)} // Dispara abertura modal
                  />
                </HStack>
              </Tooltip>
            
              <Tooltip label={labelsAcoes[1]}>
                <HStack justify="center">
                  <a
                    href={`${process.env.REACT_APP_OLDMYIPAC}/planejamento/index/${act.number_plan}?aten=${act.number_attedence}&pg=1`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <IconButton
                      aria-label="Ver planejamento"
                      icon={<FiTrello />}
                      variant="ghost"
                    />
                  </a>
                </HStack>
              </Tooltip>

            </Box>

          </Box>

        ))}

      </Table>
      

      {/* ======================================================
      MODAL DETALHES ATIVIDADE
      ====================================================== */}

      <Modal
        isOpen={isOpen} // Controla visibilidade modal
        onClose={onClose} // Fecha modal ao clicar fora ou botão fechar
        size="lg" // Tamanho modal
      >

        {/* Fundo escurecido */}
        <ModalOverlay />

        {/* Container principal */}
        <ModalContent>

          {/* Cabeçalho */}
          <ModalHeader>
            Detalhes da Atividade
          </ModalHeader>

          <ModalCloseButton />

          {/* Corpo da modal */}
          <ModalBody>

            {selectedActivity && (

              <Flex flexDir="column" gap={3}>

                {/* Funcionário */}
                <Box>
                  <Text fontWeight="bold">Funcionário:</Text>
                  <Text>{selectedActivity.employee}</Text>
                </Box>

                {/* Atividade */}
                <Box>
                  <Text fontWeight="bold">Atividade:</Text>
                  <Text>{selectedActivity.activity_name}</Text>
                </Box>

                {/* Demanda */}
                <Box>
                  <Text fontWeight="bold">Demanda:</Text>
                  <Text>{selectedActivity.demand}</Text>
                </Box>

                {/* Empresa */}
                <Box>
                  <Text fontWeight="bold">Empresa:</Text>
                  <Text>{selectedActivity.company_client}</Text>
                </Box>

                {/* Competência */}
                <Box>
                  <Text fontWeight="bold">Competência:</Text>
                  <Text>{selectedActivity.competence}</Text>
                </Box>

                {/* Status Atendimento */}
                <Box>
                  <Text fontWeight="bold">Status Atendimento:</Text>
                  <BadgeStatusInfo
                    status={selectedActivity.status_attedence}
                    statusColor={selectedActivity.status_color_attedence}
                  />
                </Box>

                {/* Status Entrega */}
                <Box>
                  <Text fontWeight="bold">Status Entrega:</Text>
                  <Tag>
                    {selectedActivity.status_entrega}
                  </Tag>
                </Box>

                {/* Tempo Executado */}
                <Box>
                  <Text fontWeight="bold">Tempo Executado do colaborador na atividade:</Text>
                  <Text>{selectedActivity.time_reconde}</Text>
                </Box>

                {/* Datas do Atendimento! */}
                <Box>
                  <Text fontWeight="bold">Início Atendimento:</Text>
                  <Text>
                    {

                      // Aplicando um operador ternário!
                      
                      selectedActivity.inicio_atendimento === null 
                      ? "Atendimento não inicíado" 
                      : selectedActivity.inicio_atendimento
                    }                    
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="bold">Fim atendimento:</Text>
                  <Text>
                    {

                      // Aplicando um operador ternário!
                      
                      // Verificamos se existe valor. Se for null ou undefined, entra no "Não finalizado"
                      !selectedActivity.fim_atendimento 
                      ? "Atendimento não finalizado" 
                      : replaceDate(selectedActivity.fim_atendimento)

                    }
                  </Text>
                </Box>

                {/* Datas planejadas */}
                <Box>
                  <Text fontWeight="bold">Data e hora inicialmente planejado:</Text>
                  <Text>
                    {
                      // aplica um ternário se um valor é diferente de nullo ou undefind!
                      !selectedActivity.start_planned 
                      ? "Atendimento não planejado!" 
                      : replaceDate(selectedActivity.start_planned)
                    }
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="bold">Data e hora fim do planejamento:</Text>
                  <Text>
                    { 
                      // aplica um ternário se um valor é diferente de nullo ou undefind!
                      !selectedActivity.end_planned 
                      ? "Atendimento não planejado!" 
                      : replaceDate(selectedActivity.end_planned)
                    }
                  </Text>
                </Box>

                <Box>
                  <Text fontWeight="bold">Tempo de Duração da Atividade Planejada:</Text>
                  <Text>
                    { 
                      // aplica um ternário se um valor é diferente de nullo ou undefind!
                      selectedActivity.duration_activity
                    }
                  </Text>
                </Box>

              </Flex>

            )}

          </ModalBody>

          {/* Rodapé */}
          <ModalFooter>

            <Button onClick={onClose} colorScheme="gray">
              Fechar
            </Button>

          </ModalFooter>

        </ModalContent>
      </Modal>

    </Box>
  );
};

export default AnalyzeActivitiesExpected;
